// extracted by mini-css-extract-plugin
export default {"option":"SuperCard_option__sOLmt","scaledIcon":"SuperCard_scaledIcon__eBc7Q","fixedDesctiprion":"SuperCard_fixedDesctiprion__LMPPM"};